import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-custom-card2',
  templateUrl: './custom-card2.component.html',
  styleUrls: ['./custom-card2.component.scss']
})
export class CustomCard2Component implements OnInit {

	@Input() id : number = -1;
	@Input() currentSelected : number = null;
	@Input() text = "TEST";
	@Input() icon = "edit";

	@Output() click : EventEmitter<number> = new EventEmitter<number>();

	clicked() { this.click.emit(this.id);	}

  constructor() { }

  ngOnInit(): void {
  }

}
